import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'iv-live-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellComponent {

  @HostBinding('class.background-change') @Input() showChangeBackground = null;
  @HostBinding('class.value-change') @Input() showChangeValue = null;
  @HostBinding('class.positive') positive = false;
  @HostBinding('class.negative') negative = false;
  private _prevRequestId;

  constructor() {
  }

  private _requestId;

  get requestId() {
    return this._requestId;
  }

  @Input() set requestId(value) {
    if (this._requestId) {
      this._prevRequestId = this._requestId;
    } else {
      this._prevRequestId = value;
    }
    this._requestId = value;
  }

  private _value;

  get value() {
    return this._value;
  }

  // ПРОСТАВЛЯЕМ ЛИБО change ЛИБО VALUE!!!!!!
  @Input() set value(value) {
    if (this._value && (this._prevRequestId === this._requestId)) {
      if (this._value === value) {
        this.positive = null;
        this.negative = null;
      } else if (this._value < value) {
        this.positive = true;
        this.negative = null;
      } else {
        this.positive = null;
        this.negative = true;
      }
    }
    this._value = value;
  }

  private _change;

  get change() {
    return this._change;
  }

  // ПРОСТАВЛЯЕМ ЛИБО change ЛИБО VALUE!!!!!!
  @Input() set change(value) {
    if (value > 0) {
      this.positive = true;
      this.negative = null;
    } else if (value < 0) {
      this.positive = null;
      this.negative = true;
    } else {
      this.positive = null;
      this.negative = null;
    }
    this._change = value;
  }
}
